import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Styles.css';

const DRIVE_FOLDER_ID = "1P1k653o8rA4RKoR44jv2WTWVWPgHge7J";
const DRIVE_EMBED_URL = `https://drive.google.com/embeddedfolderview?id=${DRIVE_FOLDER_ID}#grid`;

const PastServices = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeVideo, setActiveVideo] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [activeTab, setActiveTab] = useState('youtube'); // 'youtube' | 'drive'
  const navigate = useNavigate();

  useEffect(() => {
    const fetchYouTubeVideos = async () => {
      try {
        const apiKey = process.env.REACT_APP_YOUTUBE_API_KEY || 'AIzaSyCV3sCMuiDq2LRtymq5XWwUKZYxXSGrX30';
        
        const playlistId = 'PLNHLehE2Xl3s';
        const url = `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet,contentDetails&maxResults=50&playlistId=${playlistId}&key=${apiKey}`;
        
        const response = await fetch(url);
        const data = await response.json();
        
        if (data.items) {
          const formattedServices = data.items.map(item => {
            const snippet = item.snippet;
            if (snippet.title === 'Private video' || snippet.title === 'Deleted video') {
               return null;
            }
            
            // Use original video publish/stream date, not the date it was added to the playlist
            const rawDate = item.contentDetails?.videoPublishedAt || snippet.publishedAt;
            const date = new Date(rawDate);
            
            const optionsDate = { year: 'numeric', month: 'short', day: 'numeric' };
            const optionsDay = { weekday: 'long' };
            const optionsMonthYear = { year: 'numeric', month: 'long' };
            
            let thumbUrl = '';
            if (snippet.thumbnails) {
               if (snippet.thumbnails.maxres) thumbUrl = snippet.thumbnails.maxres.url;
               else if (snippet.thumbnails.high) thumbUrl = snippet.thumbnails.high.url;
               else if (snippet.thumbnails.medium) thumbUrl = snippet.thumbnails.medium.url;
               else if (snippet.thumbnails.default) thumbUrl = snippet.thumbnails.default.url;
            }
            
            return {
              id: snippet.resourceId.videoId,
              title: snippet.title,
              date: date.toLocaleDateString('en-US', optionsDate),
              day: date.toLocaleDateString('en-US', optionsDay),
              monthYear: date.toLocaleDateString('en-US', optionsMonthYear),
              timestamp: date.getTime(),
              thumbnail: thumbUrl || 'https://via.placeholder.com/600x338?text=Service+Archive',
              videoUrl: `https://www.youtube.com/watch?v=${snippet.resourceId.videoId}`
            };
          }).filter(Boolean);
          
          // Sort by newest first
          formattedServices.sort((a, b) => b.timestamp - a.timestamp);
          
          setServices(formattedServices);
        }
      } catch (error) {
        console.error("Error fetching YouTube videos:", error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchYouTubeVideos();
  }, []);

  useEffect(() => {
    // Cleanup modal on unmount
    return () => setActiveVideo(null);
  }, []);

  // Filter services by search query
  const filteredServices = services.filter(service => 
    service.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleAction = (e, videoId, actionType) => {
    const user = localStorage.getItem("user");
    if (!user) {
      if (e) e.preventDefault();
      navigate("/signIn");
      return;
    }
    
    if (actionType === 'watch') {
      setActiveVideo(videoId);
    }
  };

  const renderServiceCard = (service) => (
    <div key={service.id} className="service-list-item" style={{ 
      display: 'flex', 
      alignItems: 'center', 
      backgroundColor: 'rgba(29, 32, 36, 0.95)', 
      borderRadius: '12px', 
      padding: '15px', 
      gap: '25px',
      border: '1px solid rgba(93, 179, 232, 0.15)',
      boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
      flexWrap: 'wrap'
    }}>
      <div className="video-thumbnail" onClick={(e) => handleAction(e, service.id, 'watch')} style={{ width: '280px', flexShrink: 0, borderRadius: '8px', overflow: 'hidden', cursor: 'pointer' }}>
        <img src={service.thumbnail} alt={service.title} style={{ width: '100%', height: 'auto', display: 'block', objectFit: 'cover' }} />
        <div className="play-overlay">
          <div className="play-icon">▶</div>
        </div>
      </div>
      <div className="service-info" style={{ flexGrow: 1, padding: 0 }}>
        <h3 style={{
          fontSize: '1.2rem',
          lineHeight: '1.5',
          color: '#fff',
          fontWeight: '600',
          marginBottom: '15px'
        }}>{service.title}</h3>
        <div style={{ display: 'flex', gap: '15px', marginTop: '5px' }}>
          <button onClick={(e) => handleAction(e, service.id, 'watch')} className="watch-btn" style={{ border: 'none', cursor: 'pointer', fontFamily: 'Montserrat', padding: '10px 24px', fontSize: '0.95rem', borderRadius: '6px', fontWeight: 'bold' }}>
            ▶ Watch Now
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="past-services-container" style={{ position: 'relative' }}>
      <button 
        onClick={() => navigate('/')} 
        style={{
          position: 'absolute',
          top: '20px',
          left: '20px',
          background: 'none',
          border: 'none',
          color: '#fff',
          fontSize: '2rem',
          cursor: 'pointer',
          zIndex: 10,
          padding: '10px'
        }}
        title="Go Back"
      >
        ←
      </button>
      <div className="past-services-header">
        <h1>Service Archive</h1>
        <p>Watch our past services and be blessed by the Word.</p>
        <div className="search-container" style={{ marginTop: '25px', display: 'flex', justifyContent: 'center' }}>
          <input 
            type="text" 
            placeholder="Search for a service... (e.g. Midweek)" 
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            style={{ 
              width: '100%', 
              maxWidth: '500px', 
              padding: '14px 24px', 
              borderRadius: '30px', 
              border: '1px solid rgba(93, 179, 232, 0.4)', 
              background: 'rgba(18, 21, 25, 0.95)', 
              color: '#fff', 
              fontFamily: 'Montserrat', 
              fontSize: '1rem',
              outline: 'none',
              boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
              transition: 'border-color 0.3s ease'
            }} 
          />
        </div>

        {/* Navigation Tabs: YouTube Archive vs Cloud Drive Archive */}
        <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'center', gap: '12px', flexWrap: 'wrap' }}>
          <button
            onClick={() => setActiveTab('youtube')}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              backgroundColor: activeTab === 'youtube' ? 'rgba(93, 179, 232, 0.2)' : 'rgba(29, 32, 36, 0.8)',
              border: activeTab === 'youtube' ? '1px solid #5DB3E8' : '1px solid rgba(255, 255, 255, 0.1)',
              borderRadius: '25px',
              padding: '10px 22px',
              color: activeTab === 'youtube' ? '#5DB3E8' : '#aaa',
              cursor: 'pointer',
              fontFamily: 'Montserrat, sans-serif',
              fontSize: '0.92rem',
              fontWeight: '600',
              transition: 'all 0.3s ease',
              boxShadow: activeTab === 'youtube' ? '0 4px 15px rgba(93, 179, 232, 0.25)' : 'none'
            }}
          >
            <span>📺 YouTube Service Archive</span>
            <span style={{ 
              background: activeTab === 'youtube' ? '#5DB3E8' : 'rgba(255,255,255,0.1)', 
              color: activeTab === 'youtube' ? '#0a0c10' : '#888', 
              fontSize: '0.72rem', 
              padding: '2px 8px', 
              borderRadius: '12px',
              fontWeight: 'bold'
            }}>{services.length}</span>
          </button>

          <button
            onClick={() => setActiveTab('drive')}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              backgroundColor: activeTab === 'drive' ? 'rgba(93, 179, 232, 0.2)' : 'rgba(29, 32, 36, 0.8)',
              border: activeTab === 'drive' ? '1px solid #5DB3E8' : '1px solid rgba(255, 255, 255, 0.1)',
              borderRadius: '25px',
              padding: '10px 22px',
              color: activeTab === 'drive' ? '#5DB3E8' : '#aaa',
              cursor: 'pointer',
              fontFamily: 'Montserrat, sans-serif',
              fontSize: '0.92rem',
              fontWeight: '600',
              transition: 'all 0.3s ease',
              boxShadow: activeTab === 'drive' ? '0 4px 15px rgba(93, 179, 232, 0.25)' : 'none'
            }}
          >
            <svg width="18" height="18" viewBox="0 0 87.3 78" fill="none">
              <path d="m6.6 66.85 3.85 6.65c.8 1.4 1.95 2.5 3.3 3.3l13.75-23.8H0c0 1.55.4 3.1 1.2 4.5z" fill="#0066da"/>
              <path d="M43.65 25 29.9 1.2c-1.35.8-2.5 1.9-3.3 3.3L1.2 47.45c-.8 1.4-1.2 2.95-1.2 4.5h27.5z" fill="#00ac47"/>
              <path d="M73.55 76.8c1.35-.8 2.5-1.9 3.3-3.3l1.6-2.75 7.65-13.25c.8-1.4 1.2-2.95 1.2-4.5H59.8l5.85 10.15z" fill="#ea4335"/>
              <path d="M43.65 25 57.4 1.2C56.05.4 54.5 0 52.9 0H34.4c-1.6 0-3.15.45-4.5 1.2z" fill="#00832d"/>
              <path d="M59.8 53H27.5L13.75 76.8c1.35.8 2.9 1.2 4.5 1.2h50.8c1.6 0 3.15-.45 4.5-1.2z" fill="#2684fc"/>
              <path d="M73.4 26.5 60.1 3.5c-.8-1.4-1.95-2.5-3.3-3.3L43.65 25 59.8 53h27.5c0-1.55-.4-3.1-1.2-4.5z" fill="#ffba00"/>
            </svg>
            <span>Cloud Stream Drive Archive</span>
            <span style={{ 
              background: 'linear-gradient(135deg, #136488, #5DB3E8)', 
              color: '#fff', 
              fontSize: '0.72rem', 
              padding: '2px 8px', 
              borderRadius: '12px',
              fontWeight: 'bold'
            }}>DRIVE</span>
          </button>
        </div>
      </div>
      
      {activeTab === 'drive' ? (
        <div style={{ width: '100%', maxWidth: '1280px', margin: '0 auto 80px', padding: '0 20px' }}>
          <div style={{
            backgroundColor: 'rgba(29, 32, 36, 0.95)',
            borderRadius: '16px',
            padding: '25px',
            border: '1px solid rgba(93, 179, 232, 0.25)',
            boxShadow: '0 10px 40px rgba(0,0,0,0.5)'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '15px' }}>
              <div>
                <h2 style={{ color: '#5DB3E8', margin: '0 0 6px 0', fontFamily: 'Montserrat, sans-serif', fontSize: '1.4rem' }}>
                  📁 Cloud Stream Recordings
                </h2>
                <p style={{ color: '#aaa', margin: 0, fontSize: '0.92rem' }}>
                  🔒 Secure Isolated Folder: Only upcoming/recent church service recordings are displayed. Click any video to play directly.
                </p>
              </div>
              <button
                onClick={() => setActiveTab('youtube')}
                style={{
                  background: 'rgba(255,255,255,0.08)',
                  border: '1px solid rgba(255,255,255,0.2)',
                  color: '#fff',
                  padding: '8px 16px',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontFamily: 'Montserrat, sans-serif',
                  fontSize: '0.88rem',
                  fontWeight: '600',
                  transition: 'background 0.2s'
                }}
              >
                ← Back to YouTube Archive
              </button>
            </div>

            <div style={{ position: 'relative', width: '100%', height: '620px', borderRadius: '12px', overflow: 'hidden', background: '#121519' }}>
              <iframe
                src={DRIVE_EMBED_URL}
                style={{
                  width: '100%',
                  height: '100%',
                  border: 'none',
                  borderRadius: '12px'
                }}
                title="Google Drive Service Archive"
                allow="autoplay; encrypted-media"
              ></iframe>
            </div>
          </div>
        </div>
      ) : loading ? (
        <div style={{ textAlign: 'center', marginTop: '50px', color: '#5DB3E8', fontSize: '1.2rem' }}>
          Loading latest recordings...
        </div>
      ) : services.length > 0 ? (
        <div className="services-groups-container" style={{ width: '100%', maxWidth: '1280px', margin: '0 auto', padding: '0 20px', marginBottom: '80px' }}>
          
          {/* Quick Notice if looking for freshly streamed services */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            backgroundColor: 'rgba(19, 100, 136, 0.15)',
            border: '1px dashed rgba(93, 179, 232, 0.35)',
            borderRadius: '10px',
            padding: '12px 20px',
            marginBottom: '20px',
            flexWrap: 'wrap',
            gap: '12px'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <span style={{ fontSize: '1.3rem' }}>📁</span>
              <span style={{ color: '#d0d0d0', fontSize: '0.92rem' }}>
                Recent stream not yet listed below? Watch it on our Cloud Stream Drive Archive.
              </span>
            </div>
            <button
              onClick={() => setActiveTab('drive')}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                color: '#FFE066',
                background: 'none',
                border: 'none',
                fontWeight: 'bold',
                cursor: 'pointer',
                fontSize: '0.92rem',
                padding: '4px 8px'
              }}
            >
              Watch Cloud Recording Here ↓
            </button>
          </div>

          {filteredServices.length === 0 ? (
            <div style={{ 
              textAlign: 'center', 
              marginTop: '30px', 
              padding: '35px 20px', 
              background: 'rgba(29, 32, 36, 0.95)', 
              borderRadius: '12px', 
              border: '1px solid rgba(93, 179, 232, 0.2)',
              maxWidth: '650px',
              margin: '30px auto'
            }}>
              <p style={{ color: '#fff', fontSize: '1.15rem', fontWeight: '600', marginBottom: '10px' }}>
                No services found matching "{searchQuery}"
              </p>
              <p style={{ color: '#a0a0a0', fontSize: '0.92rem', marginBottom: '20px', lineHeight: '1.5' }}>
                Looking for an upcoming service or freshly streamed recording? Check our Google Drive folder:
              </p>
              <button
                onClick={() => setActiveTab('drive')}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '10px',
                  padding: '12px 24px',
                  background: 'linear-gradient(135deg, #136488, #1A2E49)',
                  color: '#fff',
                  borderRadius: '8px',
                  border: '1px solid rgba(93, 179, 232, 0.4)',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  fontSize: '0.95rem'
                }}
              >
                📁 Switch to Cloud Drive Player →
              </button>
            </div>
          ) : (
            <div className="services-list" style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              {filteredServices.map(renderServiceCard)}
            </div>
          )}

        </div>
      ) : (
        <div style={{ 
          marginTop: '60px', 
          padding: '50px', 
          background: 'rgba(29, 32, 36, 0.95)', 
          borderRadius: '16px', 
          border: '1px solid rgba(19, 100, 136, 0.3)', 
          boxShadow: '0 10px 30px rgba(0,0,0,0.5)',
          maxWidth: '600px',
          margin: '60px auto 0',
          textAlign: 'center'
        }}>
          <h2 style={{ color: '#ffcc00', margin: '0 0 15px 0', fontSize: '2.5rem', fontFamily: 'Montserrat, sans-serif' }}>Coming Soon!</h2>
          <p style={{ color: '#d0d0d0', fontSize: '1.2rem', margin: 0, lineHeight: '1.6' }}>
            We are currently setting up our video archives. Please check back later to watch all our past service recordings!
          </p>
        </div>
      )}

      {/* Video Player Modal */}
      {activeVideo && (
        <div className="video-modal-overlay" onClick={() => setActiveVideo(null)}>
          <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-modal-btn" onClick={() => setActiveVideo(null)}>×</button>
            <div className="video-wrapper">
              <iframe 
                width="100%" 
                height="100%" 
                src={`https://www.youtube.com/embed/${activeVideo}?autoplay=1`} 
                title="YouTube video player" 
                frameBorder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PastServices;
